import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white w-full border border-gray-lp-1500 rounded-xl" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "flex flex-col py-4 px-6 w-full" }
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = { class: "font-semibold text-base text-black-lp-100" }
const _hoisted_6 = { class: "flex space-x-4" }
const _hoisted_7 = { class: "flex flex-col space-y-4 mt-5" }
const _hoisted_8 = { class: "flex space-x-8 mt-10 pl-8" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "flex flex-col py-4 px-6 items-center w-full" }
const _hoisted_11 = { class: "font-semibold text-base text-black-lp-100 text-left w-full" }
const _hoisted_12 = { class: "flex flex-col mt-3 py-10 gap-2 items-center max-w-300px" }
const _hoisted_13 = { class: "font-semibold text-sm text-gray-lp-300 text-center" }
const _hoisted_14 = { class: "font-semibold text-xs text-gray-lp-800 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_VueApexCharts = _resolveComponent("VueApexCharts")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("span", _hoisted_5, _toDisplayString(_ctx.title), 1),
              _createVNode("div", _hoisted_6, [
                (_openBlock(), _createBlock(_Fragment, null, _renderList(3, (i) => {
                  return _createVNode(_component_Skeleton, {
                    key: i,
                    height: "12px",
                    width: "90px"
                  })
                }), 64))
              ])
            ]),
            _createVNode("div", _hoisted_7, [
              (_openBlock(), _createBlock(_Fragment, null, _renderList(6, (i) => {
                return _createVNode(_component_Skeleton, {
                  key: i,
                  height: "12px",
                  width: "46px"
                })
              }), 64))
            ]),
            _createVNode("div", _hoisted_8, [
              (_openBlock(), _createBlock(_Fragment, null, _renderList(12, (i) => {
                return _createVNode(_component_Skeleton, {
                  key: i,
                  height: "12px",
                  width: "100%"
                })
              }), 64))
            ])
          ])
        ]))
      : (_ctx.hasError)
        ? (_openBlock(), _createBlock("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode("span", _hoisted_11, _toDisplayString(_ctx.title), 1),
              _createVNode("div", _hoisted_12, [
                _createVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("dashboard.lineComparisonChart.systemError")), 1),
                _createVNode("span", _hoisted_14, _toDisplayString(_ctx.errorMessage || _ctx.$t("dashboard.lineComparisonChart.reloadInstruction")), 1),
                _createVNode(_component_LpButton, {
                  class: "self-center",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('reload'))),
                  title: _ctx.$t('dashboard.lineComparisonChart.reload'),
                  textColor: "white",
                  fontWeight: "semibold",
                  iconLeft: "reload-white",
                  sizeIcon: "12px"
                }, null, 8, ["title"])
              ])
            ])
          ]))
        : (_openBlock(), _createBlock(_component_VueApexCharts, {
            key: 2,
            options: _ctx.chartOptions,
            series: _ctx.series,
            height: _ctx.height,
            type: "area"
          }, null, 8, ["options", "series", "height"]))
  ]))
}